import styled from 'styled-components';
import { 
  Text, 
  Card, 
  Flex, 
  Grid, 
  BaseButton, 
  Badge,
  theme 
} from '../../styles';

// Descrição da página
export const PageDescription = styled(Text)`
  margin: 0;
`;

// Header components
export const HeaderLeft = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${theme.spacing[2]};
`;

export const HeaderActions = styled.div`
  display: flex;
  gap: ${theme.spacing[3]};
  align-items: center;
`;

// Filtros
export const FiltersContainer = styled(Card)`
  margin-bottom: ${theme.spacing[6]};
`;

export const FiltersRow = styled(Flex)`
  flex-wrap: wrap;
`;

export const SearchInputWrapper = styled.div`
  position: relative;
  flex: 1;
  min-width: 300px;
`;

export const SearchIcon = styled.div`
  position: absolute;
  left: ${theme.spacing[3]};
  top: 50%;
  transform: translateY(-50%);
  color: ${theme.colors.text.tertiary};

  svg {
    width: 18px;
    height: 18px;
  }
`;

// Grid e Cards
export const AnosLetivosGrid = styled(Grid)`
  grid-template-columns: repeat(auto-fill, minmax(350px, 1fr));
`;

export const AnoLetivoCard = styled(Card)`
  transition: all ${theme.transitions.fast};

  &:hover {
    box-shadow: ${theme.shadows.lg};
    transform: translateY(-2px);
  }
`;

export const CardHeader = styled(Flex)`
  margin-bottom: ${theme.spacing[4]};
`;

export const AnoTitle = styled.h3`
  font-size: ${theme.typography.fontSize['2xl']};
  font-weight: ${theme.typography.fontWeight.bold};
  color: ${theme.colors.text.primary};
  margin: 0;
  display: flex;
  align-items: center;
  gap: ${theme.spacing[2]};
`;

export const CardActions = styled(Flex)`
  gap: ${theme.spacing[2]};
`;

export const ActionButton = styled(BaseButton)<{ variant?: 'edit' | 'delete' }>`
  width: 32px;
  height: 32px;
  min-width: 32px;
  padding: 0;

  ${props => props.variant === 'edit' && `
    background-color: ${theme.colors.gray[100]};
    color: ${theme.colors.gray[700]};

    &:hover:not(:disabled) {
      background-color: ${theme.colors.gray[200]};
      color: ${theme.colors.gray[800]};
    }
  `}

  ${props => props.variant === 'delete' && `
    background-color: ${theme.colors.error[100]};
    color: ${theme.colors.error[600]};

    &:hover:not(:disabled) {
      background-color: ${theme.colors.error[200]};
      color: ${theme.colors.error[700]};
    }
  `}

  svg {
    width: 16px;
    height: 16px;
  }
`;

// Status components
export const StatusContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${theme.spacing[3]};
  margin-bottom: ${theme.spacing[5]};
`;

export const StatusItem = styled(Flex)`
  justify-content: space-between;
  align-items: center;
`;

export const StatusLabel = styled(Text)`
  font-weight: ${theme.typography.fontWeight.medium};
`;

export const StatusBadge = styled(Badge)<{ active: boolean }>`
  display: flex;
  align-items: center;
  gap: ${theme.spacing[1]};
  ${props => props.active ? `
    background-color: ${theme.colors.success[100]};
    color: ${theme.colors.success[800]};
  ` : `
    background-color: ${theme.colors.error[100]};
    color: ${theme.colors.error[800]};
  `}
`;

export const ToggleButton = styled(BaseButton)<{ isActive: boolean }>`
  border-radius: ${theme.borderRadius.full};
  font-size: ${theme.typography.fontSize.xs};
  font-weight: ${theme.typography.fontWeight.medium};
  padding: ${theme.spacing[1]} ${theme.spacing[3]};
  gap: ${theme.spacing[1]};
  min-height: auto;

  ${props => props.isActive ? `
    background-color: ${theme.colors.success[500]};
    color: ${theme.colors.text.inverse};

    &:hover:not(:disabled) {
      background-color: ${theme.colors.success[600]};
    }
  ` : `
    background-color: ${theme.colors.gray[500]};
    color: ${theme.colors.text.inverse};

    &:hover:not(:disabled) {
      background-color: ${theme.colors.gray[600]};
    }
  `}

  svg {
    width: 14px;
    height: 14px;
  }
`;

export const CardFooter = styled.div`
  padding-top: ${theme.spacing[4]};
  border-top: 1px solid ${theme.colors.border.light};
  font-size: ${theme.typography.fontSize.xs};
  color: ${theme.colors.text.secondary};
`;
